import { Col, Container, Row } from "reactstrap";
import { P} from "../../AbstractElements";

const Footer = () => {
  return (
    <footer className="footer">
      <Container fluid>
        <Row>
          <Col md="6" className="p-0 footer-copyright">
            <P className="mb-0">
              Copyright {new Date().getFullYear()} © Linnk Group
            </P>
          </Col>
        
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
